/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * GameLockBase
 * auto generated base class for the model GameLockModel.
 */
export const GameLockModelBase = ModelBase.named('GameLock')
  .props({
    __typename: types.optional(types.literal('GameLock'), 'GameLock'),
    isLocked: types.union(types.undefined, types.boolean),
    lockedUsers: types.union(types.undefined, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameLockModelSelector extends QueryBuilder {
  get isLocked() {
    return this.__attr('isLocked')
  }
  get lockedUsers() {
    return this.__attr('lockedUsers')
  }
}
export function selectFromGameLock() {
  return new GameLockModelSelector()
}

export const gameLockModelPrimitives = selectFromGameLock().isLocked.lockedUsers
